import React from 'react';
import {Config} from "../Config";

export default function Landing(prop) {

    let [landing, setLanding] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const landingListing = await getLanding();
                if(landingListing.count === 0) {
                    window.location = '/home';
                }
                else {
                    setLanding(landingListing);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getLanding() {
        const response = await fetch(Config.apiUrl +'landing/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            {
                landing && landing.count > 0 ?
                    <div className="section">
                        <div className="container text-center">
                            <img src={Config.fileUpload + "landing/" + landing.rows[0].image} className="img-fluid" />

                            <div className="mt-2">
                                <a href={prop.lang === 'en' ? '/en/home':'/home'} className="btn d-inline-block px-4 mt-2 mx-2">{prop.lang === 'en' ? 'Enter Website':'เข้าสู่เว็บไซต์'}</a>

                                {
                                    prop.lang === 'en' ?
                                        (landing.rows[0].link_en && landing.rows[0].link_text_en ? <a href={landing.rows[0].link_en} className="btn btn-light d-inline-block px-4 mt-2 mx-2" target="_blank">{landing.rows[0].link_text_en}</a> : '') :
                                        (landing.rows[0].link && landing.rows[0].link_text ? <a href={landing.rows[0].link} className="btn btn-light d-inline-block px-4 mt-2 mx-2" target="_blank">{landing.rows[0].link_text}</a> : '')
                                }
                            </div>
                        </div>
                    </div>
                    : ''
            }
        </>
    )
}